// Action Types
export const FETCH_SPOT_CONTACTS_REQUEST = "FETCH_SPOT_CONTACTS_REQUEST";
export const FETCH_SPOT_CONTACTS_SUCCESS = "FETCH_SPOT_CONTACTS_SUCCESS";
export const FETCH_SPOT_CONTACTS_FAILURE = "FETCH_SPOT_CONTACTS_FAILURE";

// Action Creators
export const FetchSpotContactsRequest = ({ clientName,accountName,userId,type}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_SPOT_CONTACTS_REQUEST,
      payload: { clientName, accountName, userId, type },
    });
  };
};
export const FetchSpotContactsSuccess = (data) => ({
  type: FETCH_SPOT_CONTACTS_SUCCESS,
  payload: data,
});
export const FetchSpotContactsFailure = (error) => ({
  type: FETCH_SPOT_CONTACTS_FAILURE,
  payload: error,
});
